import baseClient from '@/clients/baseClient';
const getAll = () => baseClient.get('questionnaires');
const save = (questionnaire) => baseClient.post('questionnaires', questionnaire);

const getAllTable = (params) => {
    const queryString = new URLSearchParams(params).toString();
    return baseClient.get(`questionnaires/table?${queryString}`);
};

const getAllById = (id) => {    
    return baseClient.get(`questionnaires/${id}`);
};

const getAllCompletedTable = (params) => {
    const queryString = new URLSearchParams(params).toString();
    return baseClient.get(`questionnaires/table/completed?${queryString}`);
};

const getQuestionnairePrioritizationByQuestionnaireId = (questionnaireId) => {
    return baseClient.get(`questionnaires/${questionnaireId}/prioritization`);
}

const getWorkPlanByQuestionnaireId = (questionnaireId) => {
    return baseClient.get(`questionnaires/${questionnaireId}/work-plan`);
}

const saveQuestionnairePrioritizationByQuestionnaire = (questionnaireId, prioritization) => {
    return baseClient.post(`questionnaires/${questionnaireId}/prioritization`, prioritization);
}

const updateQuestionnaireWorkPlanElementTraining = (workPlanElementId, trainingId) => {
    return baseClient.put(`questionnaires/work-plan/${workPlanElementId}/training/${trainingId}`);
}

const updateQuestionnaireWorkPlanElementTrainingText = (workPlanElementId, payload) => {
    return baseClient.put(`questionnaires/work-plan/${workPlanElementId}/training-text`, payload);
}

const updateQuestionnaireWorkPlanQuestionDetail = (questionDetailId, question) => {
    return baseClient.put(`questionnaires/work-plan/question-detail/${questionDetailId}`, question);
}

const getQuestionDetailTrackingLogs = (questionDetailId) => {
    return baseClient.get(`questionnaires/work-plan/question-detail/${questionDetailId}/log`);
}

const getQuestionDetailFinalEvaluation = (questionDetailId) => {
    return baseClient.get(`questionnaires/work-plan/question-detail/${questionDetailId}/final-evaluation`);
}

const saveQuestionDetailTrackingLog = (questionDetailId, questionLog) => {
    return baseClient.post(`questionnaires/work-plan/question-detail/${questionDetailId}/log`, questionLog);
}

const saveQuestionDetailFinalEvaluation = (questionDetailId, evaluation) => {
    return baseClient.post(`questionnaires/work-plan/question-detail/${questionDetailId}/final-evaluation`, evaluation);
}

const getQuestionDetailPdf = (questionDetailId) => {
    return baseClient.get(`questionnaires/work-plan/question-detail/${questionDetailId}/pdf`, { responseType: 'blob' });
}

const updateQuestionnaireWorkPlanAdditionalInformation = (additionalInformationId, additionalInformation) => {
    return baseClient.put(`questionnaires/work-plan/additional-information/${additionalInformationId}`, additionalInformation);
}

const getAdditionalInformationTrackingLogs = (additionalInformationId) => {
    return baseClient.get(`questionnaires/work-plan/additional-information/${additionalInformationId}/log`);
}

const getAdditionalInformationFinalEvaluation = (additionalInformationId) => {
    return baseClient.get(`questionnaires/work-plan/additional-information/${additionalInformationId}/final-evaluation`);
}

const saveAdditionalInformationTrackingLog = (additionalInformationId, additionalInformationLog) => {
    return baseClient.post(`questionnaires/work-plan/additional-information/${additionalInformationId}/log`, additionalInformationLog);
}

const saveAdditionalInformationFinalEvaluation = (additionalInformationId, evaluation) => {
    return baseClient.post(`questionnaires/work-plan/additional-information/${additionalInformationId}/final-evaluation`, evaluation);
}

const getWorkPlanProcessOptions = (questionnaireId, prioritizationId, sourceType, selectedItemId = null) => {
    const query = new URLSearchParams({ sourceType });
    if (selectedItemId != null) {
        query.append('selectedItemId', selectedItemId);
    }
    return baseClient.get(`questionnaires/${questionnaireId}/work-plan/blocks/${prioritizationId}/proceso-options?${query.toString()}`);
}

const createWorkPlanProcess = (questionnaireId, prioritizationId, payload) => {
    return baseClient.post(`questionnaires/${questionnaireId}/work-plan/blocks/${prioritizationId}/process`, payload);
}

const updateWorkPlanProcess = (processId, payload) => {
    return baseClient.put(`questionnaires/work-plan/process/${processId}`, payload);
}

const deleteWorkPlanProcess = (processId) => {
    return baseClient.delete(`questionnaires/work-plan/process/${processId}`);
}

const getWorkPlanProcessTrackingLogs = (processId) => {
    return baseClient.get(`questionnaires/work-plan/process/${processId}/log`);
}

const saveWorkPlanProcessTrackingLog = (processId, log) => {
    return baseClient.post(`questionnaires/work-plan/process/${processId}/log`, log);
}

const getWorkPlanProcessFinalEvaluation = (processId) => {
    return baseClient.get(`questionnaires/work-plan/process/${processId}/final-evaluation`);
}

const saveWorkPlanProcessFinalEvaluation = (processId, evaluation) => {
    return baseClient.post(`questionnaires/work-plan/process/${processId}/final-evaluation`, evaluation);
}

const deleteQuestionnaire = (id) => {
    return baseClient.delete(`questionnaires/${id}`);
}

const reopenDiagnostic = (id, reason) => {
    return baseClient.put(`questionnaires/${id}/reopen`, { reason: reason || null });
}

const getReopenLog = (id) => {
    return baseClient.get(`questionnaires/${id}/reopen-log`);
}

export default {
    getAll,
    getAllTable,
    getAllById,
    getAllCompletedTable,
    save,
    getQuestionnairePrioritizationByQuestionnaireId,
    saveQuestionnairePrioritizationByQuestionnaire,
    getWorkPlanByQuestionnaireId,
    updateQuestionnaireWorkPlanElementTraining,
    updateQuestionnaireWorkPlanElementTrainingText,
    updateQuestionnaireWorkPlanQuestionDetail,
    getQuestionDetailTrackingLogs,
    getQuestionDetailFinalEvaluation,
    saveQuestionDetailTrackingLog,
    saveQuestionDetailFinalEvaluation,
    getQuestionDetailPdf,
    updateQuestionnaireWorkPlanAdditionalInformation,
    getAdditionalInformationTrackingLogs,
    getAdditionalInformationFinalEvaluation,
    saveAdditionalInformationTrackingLog,
    saveAdditionalInformationFinalEvaluation,
    getWorkPlanProcessOptions,
    createWorkPlanProcess,
    updateWorkPlanProcess,
    deleteWorkPlanProcess,
    getWorkPlanProcessTrackingLogs,
    saveWorkPlanProcessTrackingLog,
    getWorkPlanProcessFinalEvaluation,
    saveWorkPlanProcessFinalEvaluation,
    deleteQuestionnaire,
    reopenDiagnostic,
    getReopenLog
}